import { useEffect, useMemo, useState } from 'react';
import { useQueryState } from 'nuqs';
import { useDebounceValue } from 'usehooks-ts';

export interface SearchFilter {
  filter?: Record<string, unknown>;
  filter_or?: Record<string, unknown>;
  filter_and_or?: Record<string, unknown>;
}

interface Props {
  toBackend?: (value: string) => SearchFilter;
}
export const useQuerySearch = ({ toBackend }: Props = {}) => {
  const [queryValue, setQueryValue] = useQueryState('q', {
    defaultValue: '',
  });

  const [localSearch, setLocalSearch] = useState(queryValue);
  const [debouncedSearch] = useDebounceValue(localSearch, 500);

  useEffect(() => {
    if (debouncedSearch !== queryValue) {
      setQueryValue(debouncedSearch || '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearch]);

  const backendSearch = useMemo(() => toBackend?.(queryValue) || null, [queryValue, toBackend]);

  return {
    localSearch,
    setLocalSearch,
    querySearch: queryValue,
    backendSearch,
  };
};
